import { Typography } from '@mui/material'

export const RemarkLabel: React.FC<{ text: string }> = ({ text }) => {
  return (
    <Typography variant='subtitle2' component='div' sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
      {text}
    </Typography>
  )
}
export default RemarkLabel
